import React from 'react';
import Home from './pages/homepage/home';

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
